var variant_selector_default = (() => {
    if (customElements.get("variant-selector")) return;
    customElements.define("variant-selector", class VariantSelector extends HTMLElement {
        connectedCallback() {
            this.productId = +this.dataset.productId;
            this.radios = this.querySelectorAll("[data-option-radio]");
            this.valueContainers = this.querySelectorAll("[data-value]");
            this.lowStockRed = +this.dataset.lowStockRed || Infinity;
            this.lowStockOrange = +this.dataset.lowStockOrange || Infinity;
            this.variantData = this.parseVariantData();
            this.currentVariant = void 0;
            this.radios.forEach(radio => radio.addEventListener("change", this.onChange));
            this.init();
        }
        disconnectedCallback() {
            this.radios?.forEach(radio => radio.removeEventListener("change", this.onChange));
        }
        init() {
            if (!this.getSelectedOptions().some(v => v !== void 0 && v !== null) && this.variantData.length > 1) {
                const firstAvailable = this.variantData.find(v => v.available);
                if (firstAvailable) firstAvailable.options.forEach((value, index) => {
                    const radio = this.querySelector(`input[name="option${index + 1}"][value="${value}"]`);
                    if (radio) radio.checked = true;
                });
            }
            this.onChange();
        }
        onChange=event => {
            const userInitiated = event instanceof Event;
            const options = this.getSelectedOptions();
            const variant = this.resolveVariant(options);
            this.updateOptionAvailability();
            this.updateStockIndicators();
            this.updateURL(variant);
            this.dispatchChange(variant, options, userInitiated);
            this.currentVariant = variant;
        };
        getSelectedOptions() {
            return [ ...new Set([ ...this.radios ].map(r => r.name)) ].map(name => this.querySelector(`input[name="${name}"]:checked`)?.value);
        }
        resolveVariant(options) {
            if (this.variantData.length <= 1) return this.variantData[0];
            return this.variantData.find(variant => variant.options.every((option, index) => options[index] === option));
        }
        updateOptionAvailability() {
            this.radios.forEach(radio => {
                const position = parseInt(radio.name.replace("option", ""), 10) - 1;
                const value = radio.value;
                if (this.variantData.some(variant => variant.available && variant.options[position] === value)) radio.removeAttribute("aria-out-of-stock"); else radio.setAttribute("aria-out-of-stock", "");
            });
        }
        updateStockIndicators() {
            this.valueContainers.forEach(container => {
                const dot = container.querySelector("[data-low-stock]");
                if (!dot) return;
                const radio = container.querySelector("[data-option-radio]");
                if (!radio) return;
                const position = parseInt(radio.name.replace("option", ""), 10) - 1;
                const value = radio.value;
                const matching = this.variantData.filter(variant => variant.available && variant.options[position] === value && variant.inventory_management === "shopify" && variant.inventory_policy === "deny");
                if (matching.length === 0) {
                    dot.hidden = true;
                    return;
                }
                const lowest = Math.min(...matching.map(v => v.inventory_quantity));
                if (lowest <= 0) {
                    dot.hidden = true;
                    return;
                }
                if (lowest <= this.lowStockRed) {
                    dot.hidden = false;
                    dot.style.backgroundColor = "var(--red-tone-900)";
                } else if (lowest <= this.lowStockOrange) {
                    dot.hidden = false;
                    dot.style.backgroundColor = "var(--red-tone-300)";
                } else dot.hidden = true;
            });
        }
        updateURL(variant) {
            if (!this.hasAttribute("data-url")) return;
            if (this.variantData.length <= 1 || !variant || this.hasAttribute("data-modal")) return;
            const url = new URL(window.location.href);
            url.searchParams.set("variant", variant.id);
            const newUrl = `${this.dataset.url}${url.searchParams.toString() ? `?${url.searchParams}` : ""}`;
            window.history.replaceState({
                path: newUrl
            }, "", newUrl);
        }
        dispatchChange(variant, options, userInitiated = false) {
            this.dispatchEvent(new CustomEvent("variant:change", {
                bubbles: true,
                detail: {
                    variant: variant,
                    previousVariant: this.currentVariant,
                    productId: this.productId,
                    options: options,
                    userInitiated: userInitiated,
                    modal: this.hasAttribute("data-modal")
                }
            }));
        }
        parseVariantData() {
            const variantEl = this.querySelector("[data-variant-json]");
            if (variantEl) try {
                return JSON.parse(variantEl.textContent);
            } catch {}
            const productEl = this.querySelector("[data-product-json]");
            if (productEl) try {
                return JSON.parse(productEl.textContent).variants;
            } catch {}
            return [];
        }
    });
})();